import * as types from '../index';


export const otherExpListAction = (data) => {
    return {
    type: types.OTHER_EXP_LIST,
    data
    }
};


export const otherExpAddAction = (data) => {
    return {
    type: types.OTHER_EXP_ADD,
    data
    }
};

export const otherExpEditAction = (data) => {
    return {
    type: types.OTHER_EXP_EDIT,
    data
    }
};

export const otherExpUpdateAction = (data) => {
    return {
    type: types.OTHER_EXP_UPDATE,
    data
    }
};

export const otherExpDeleteAction = (data) => {
    return {
    type: types.OTHER_EXP_DELETE,
    data
    }
};